import { render } from "./Guides.vue?vue&type=template&id=177b3a32"
import script from "./Guides.vue?vue&type=script&lang=js"
export * from "./Guides.vue?vue&type=script&lang=js"

import exportComponent from "/home/ydf/remit/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__